import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../Common/Dialog/DialogComponents";
import { ReactComponent as DeleteRoundIcon } from "Assets/Icons/DeleteRoundIcon.svg";
//import { ReactComponent as Urgent } from "Assets/Icons/Urgent.svg";
import { makeStyles } from "@mui/styles";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { ReactComponent as Info } from "Assets/Icons/info.svg";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
        },
      },
    },
  },
  dialogActionBtn: {
    marginBottom: "20px",
    "&>button": {
      width: "150px",
    },
  },
  iconStyle: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
    "&>path": {
      fill: "#5A6872",
    },
  },
  iconDeleteStyle: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
  },
  rsAlertIcon: {
    marginTop: "10px !important",
    height: "100px !important",
    width: "100px !important",
    "&>path": {
      fill: "#5A6872",
      fillOpacity: "0.6",
    },
  },
  infoIcon: {
    marginLeft: "3px",
    marginBottom: "-9px",
    width: "20px",
    cursor: "pointer",
  },
}));

const ConfirmationOrderDialog = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    title = "",
    body,
    actionBtnTitle = "",
    handleSubmit = () => {},
    loading = false,
    subTitle,
    warning,
    setCreateMultiOrder,
    add,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        maxWidth={"sm"}
        open={open}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <PrimaryDialogTitle handleClose={handleClose} />
        <Box className={classes.resConfirmationBox}>
          <DialogContent>
            <>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Typography variant="h3" medium>
                  {add === "add"
                    ? "Change next order date for the group?"
                    : "Add next order date for the group ?"}
                </Typography>
              </Box>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Typography variant="h4" regular>
                  This will reset the order dates for every patient in this
                  group!
                </Typography>
              </Box>
            </>
          </DialogContent>
        </Box>
        <DialogActions className={classes.dialogActionBtn}>
          <Button
            variant="contained"
            disabled={loading}
            startIcon={
              loading && <CircularProgress size="20px" color="white" />
            }
            type="submit"
            onClick={() => {
              handleSubmit();
              // setCreateMultiOrder(true);
            }}
          >
            Ok
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ConfirmationOrderDialog;
